/* eslint-disable react-hooks/exhaustive-deps */
import React, {useState, useEffect, useRef} from 'react';
import PageWrapper from '../../../modules/PageWrapper';
import {observer} from 'mobx-react';
import {useStore} from '../../../../store/store';
import {Link} from 'react-router-dom';
import {Button} from '../../../shared/Buttons';
import Filters from '../../../table/new/filters/Filters';
import Presets from '../../../table/new/Presets';
import {getFilters} from './getFilters';
import {facebookStatisticsFilters} from './filtersConfigs';
import {facebookStatisticsGroups} from './groupsConfigs';
import TableWrapper from '../../../table/new/TableWrapper';
import Columns from '../../../table/new/Columns';
import {baseFields} from '../../../table/new/customizationTable';
import BlankSheet from '../../../table/new/BlankSheet';
import FullScreen from '../../../table/new/FullScreen';
import Refresh from '../../../table/new/Refresh';
import ResultsCount from '../../../table/new/ResultsCount';
import Search from '../../../table/new/SearchForTable';

const PwaList = () => {
  const store = useStore();
  const [prevTimeConfig, setPrevTimeConfig] = useState(null);
  const [editItemId, setEditItemId] = useState(null);

  return (
    <PageWrapper
      prevTimeConfig={prevTimeConfig}
      firstTimeConfig='current_month'
      breadcrumbs={[
        {title: 'Приложения'},
        {isSeparator: true},
        {title: 'PWA', path: '/app/pwa', isActive: true},
      ]}
      title={
        <span>
          <i className='bi bi-phone fs-3 me-1 text-dark'></i>
          PWA
        </span>
      }
    >
      <TableWrapper
        setPrevTimeConfig={setPrevTimeConfig}
        prevTimeConfig={prevTimeConfig}
        getMethod={'PWA/getStatistics'}
        getFilters={getFilters}
        setEditItemId={setEditItemId}
        edit={null}
        defaultFilters={[
          {filter: 'app_type', isFixed: true, isHidden: true, options: ['pwa']},
          {filter: 'state', isFixed: true, options: ['recently_created', 'with_data']},
        ]}
        defaultGroups={[
          {group: 'app', isFixed: true},
          // {group: 'traffic_source', isFixed: false},
        ]}
        //на випадок якщо нам взагалі не потрібно показувати вибір груп
        hasHiddenGroups={false}
        baseFields={baseFields.filter((item) => item.value !== 'chats')}
        disabledByDefault={['reg2rs', 'chat2rs', 'lead2rs', 'click2rs']}
      >
        <Filters
          facebookStatisticsFilters={facebookStatisticsFilters}
          facebookStatisticsGroups={facebookStatisticsGroups}
          childrenNearGroups={
            <>
              {!(store.roles.includes(13) || store.roles.includes(32)) && (
                <Link to={'/app/constructor'}>
                  <Button>
                    <>
                      <i className='ki-duotone ki-plus fs-2'></i>Создать
                    </>
                  </Button>
                </Link>
              )}
              <Search />
            </>
          }
          childrenPresets={
            <>
              <ResultsCount />
              <BlankSheet />
              <Columns />
              <Presets />
              <FullScreen />
            </>
          }
          childrenHead={false}
          childrenRefresh={false}
          childrenByFilters={<Refresh />}
        />
      </TableWrapper>
    </PageWrapper>
  );
};

export default observer(PwaList);
